export const ChevronRightThinIcon = ({
  width = 24,
  height = 24,
  className,
  title = "Next",
  ...rest
}: IconProps) => (
  <svg
    data-testid="chevron-right-thin-icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...rest}>
    <title>{title}</title>
    <path d="M9 5l7 7-7 7" />
  </svg>
);
